module.exports = __webpack_public_path__ + "static/media/ekg_holter.e2f634ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/ekg_holter.jpg
// module id = 417
// module chunks = 0